var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"floatDrag",staticClass:"float-position",style:({
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    left: _vm.left + 'px',
    top: _vm.top + 'px',
    zIndex: _vm.zIndex
  }),on:{"touchmove":function($event){$event.preventDefault();},"mousemove":function($event){$event.preventDefault();},"mousedown":_vm.mouseDown,"mouseup":_vm.mouseUp}},[_vm._t("content")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd0a204c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/dragButton/src/index.vue
// module id = null
// module chunks = 